module.exports = __webpack_public_path__ + "ptc_nakagawa_U1.be2e7469.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_U1.jpg
// module id = XU5P
// module chunks = 0